import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Sidebar from './Sidebar';
import DepartmentImage from '../../../assets/image/department/businessman-pointing-his-presentation-futuristic-digital-screen_53876-102617.jpg';
import DepartmentImage2 from '../../../assets/image/department/hand-drawn-innovation-concept-with-flying-rocket_23-2149161408.jpg';

function InnovationTechnology() {

  const [Faq, setFaq] = useState(0);

  const Drop = [
    {
      Que: "What digital transformation initiatives are underway?",
      Answer: "The Department of Innovation and Technology is implementing e-government services and enhancing digital infrastructure."
    },
    {
      Que: "How does this department support tech startups?",
      Answer: "We offer funding opportunities, mentorship programs, and access to innovation hubs."
    },
    {
      Que: "What cybersecurity measures are in place?",
      Answer: "Our department ensures the security of government data and infrastructure through robust cybersecurity policies and training programs."
    }
  ];

  return (
    <>
      <section className="department-details-section">
        <div className="container">
          <div className="row">

            {/* Sidebar */}
            <div className="col-12 col-lg-4 col-xl-4">
              <Sidebar />
            </div>

            {/* Main Content */}
            <div className="col-lg-8">
              <div className="department-details-imgbox">
                <img src={DepartmentImage} className="img-fluid" alt="Innovation and Technology" />
              </div>

              <div className="department-details-content-box">
                <h4 className="department-details-title">Innovation and Technology</h4>
                <p>
                  The Department of Innovation and Technology is at the forefront of digital transformation, driving advancements in public services and fostering technological growth. 
                  Our mission is to enhance efficiency and accessibility through cutting-edge technology solutions.
                </p>
              </div>

              <div className="department-details-box">
                <div className="department-details-policy">
                  <span>
                    Leading the charge in digital innovation for a smarter government.
                  </span>
                </div>
                <p>
                  Our department is committed to supporting innovation across sectors, improving public access to digital services, and safeguarding technological assets.
                </p>
              </div>

              <div className="department-details-benefits-inner-box">
                <div className="row row-gutter-30">
                  <div className="col-lg-6">
                    <div className="department-details-benefits-box-image">
                      <img src={DepartmentImage2} className="img-fluid" alt="Digital Transformation" />
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <div className="department-details-benefits-box">
                      <h3>Our Benefits</h3>
                      <p>
                        Empowering innovation to meet the needs of a digital future.
                      </p>
                      <ul className="list-unstyled list-style">
                        <li>
                          <Link to="/department/technology/digital-transformation">
                            <i className="fa-solid fa-circle-arrow-right" style={{ marginRight: '5px' }} />
                            Digital Transformation and Smart City Projects
                          </Link>
                        </li>
                        <li>
                          <Link to="/department/technology/it-support">
                            <i className="fa-solid fa-circle-arrow-right" style={{ marginRight: '5px' }} />
                            Public Sector IT Support and Solutions
                          </Link>
                        </li>
                        <li>
                          <Link to="/department/technology/data-security">
                            <i className="fa-solid fa-circle-arrow-right" style={{ marginRight: '5px' }} />
                            Data Security and Privacy Management
                          </Link>
                        </li>
                        <li>
                          <Link to="/department/technology/digital-services">
                            <i className="fa-solid fa-circle-arrow-right" style={{ marginRight: '5px' }} />
                            Citizen-Focused Digital Services
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <div className="accordian-box">
                {Drop.map((items, index) => (
                  <div className={`accordian-box-item ${Faq !== index && "active"}`} key={index}>
                    <div className="accordian-title">
                      <h5>{items.Que}</h5>
                      <i className="fa-solid fa-angle-right" onClick={() => setFaq(index)} />
                    </div>

                    {Faq === index && (
                      <div className="accordian-content" style={{ display: "block" }}>
                        <p>{items.Answer}</p>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default InnovationTechnology;
